<template>
  <resource-base
    :loading-display="false"
    :is-management-mode="isManagementMode"
  >
    <template v-slot:display>
      <b-container>
        <display :publishing="publishing" :resource="resource" />
      </b-container>
    </template>
    <template v-slot:activity>
      <activity :resource="resource" />
    </template>
    <template v-slot:settings>
      <settings
        :publishing="publishing"
        :resource="resource"
        @udpated-settings-base="handleUpdatedSettings"
        @added-resource-item="handleUpdatedSettings"
      />
    </template>
  </resource-base>
</template>
<script>
import ResourceBase from "../resourceBase";
import Display from "./sections/display";
import Activity from "./sections/activity";
import Settings from "./sections/settings";
import { mapGetters } from "vuex";

export default {
  name: "ResourceShop",
  components: {
    ResourceBase,
    Display,
    Activity,
    Settings
  },
  props: {
    publishing: {
      type: Object,
      required: false,
      default: () => {}
    },
    resource: {
      type: Object,
      required: false,
      default: () => {}
    },
    isManagementMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false,
      title: this.resource.name,
      imgURL: this.resource.imgURL,
      faIcon: this.resource.icon ? this.resource.icon : "fa-folder"
    };
  },
  computed: {
    ...mapGetters({
      user: "user/user"
    }),
    settings() {
      return this.resource && this.resource.data && this.resource.data.settings
        ? this.resource.data.settings
        : null;
    }
  },
  methods: {
    handleUpdatedSettings() {
      //TODO:Should just refresh this publishing document
      this.$emit("refresh-publishing");
    },
    showResource() {
      this.show = true;
    }
  },
  mounted() {
    console.log(`ResourceShop Store is  ${this.$store}`);
  }
};
</script>

<style lang="scss">
img {
  cursor: pointer;
}

.video {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.youtube-player {
  border: 1px solid #1d740c;
  height: 390px;
  width: 480px;
  padding: 0px;
  margin-left: 25px;
  margin-bottom: 25px;
}
</style>
